import React, { useEffect, useState } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { BiSolidPencil } from 'react-icons/bi';
import { IoMdCheckmark, IoMdClose } from 'react-icons/io';
import { toast } from 'react-toastify';
import { postRequest } from '../../../../../../hooks/axiosClient';
import { ProductSvg } from '../../../../CustomSvg';

 
const DraggablePinItem = ({ pin, product, fromGroupId, onRemove, onEdit, onRefresh }) => {
    const [isEdit, setIsEdit] = useState(false);

    const [{ isDragging }, drag, preview] = useDrag({
        type: 'product_pin',
        item: { pin, fromGroupId },
        collect: (monitor) => ({ isDragging: monitor.isDragging() }),
    });
 
    useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true });
    }, [preview]);

    const handleChange = (e) =>
        setIsEdit((prev) => ({ ...prev, name: e.target.value }));

    const updateName = async () => {
        if (!isEdit?.name || isEdit.name.trim() === '') {
            toast.error('Please type a name.');
            return;
        }
        try {
            const response = await postRequest('group-product', isEdit);
            if (response?.type === 1) {
                setIsEdit(false);
                onRefresh?.();
            }
        } catch (err) {
            console.error('Update sub-pin name failed:', err);
        }
    };

    return (
        <div
            ref={isEdit ? null : drag}
            className="drag-wrpr"
            style={{
                opacity:    isDragging ? 0.4 : 1,
                cursor:     isDragging ? 'grabbing' : 'grab',
                gap:        isEdit ? '0.5rem' : 0,
                transition: 'opacity 0.15s',
            }}
        >
            <div className="drag-item">
                <div className="magical-words">
                    <div>
                        <ProductSvg color={product?.product_color ?? '#6A6D73'} />
                    </div>

                    {isEdit ? (
                        <input
                            className="form-control ml-2"
                            value={isEdit?.name ?? ''}
                            onChange={handleChange}
                            onKeyDown={(e) => { if (e.key === 'Enter') updateName(); }}
                            autoFocus
                        />
                    ) : (
                        <div>
                            <p>
                                {pin?.name}
                                {product?.floor_plan && ` (${product.floor_plan})`}
                            </p>
                        </div>
                    )}
                </div>

                {!isEdit && (
                    <>
                        <div className="flex-grow-1" />
                        <div
                            className="edit-square magical-words"
                            title="Edit pin"
                            onClick={() => onEdit?.(pin, 'subpin')}
                        >
                            <BiSolidPencil fontSize={15} />
                        </div>
                    </>
                )}
            </div>

            {isEdit ? (
                <>
                    <div
                        className="edit-square magical-words"
                        style={{ marginBottom: '8px' }}
                        onClick={updateName}
                        title="Save name"
                    >
                        <IoMdCheckmark fontSize={15} />
                    </div>
                    <div
                        className="edit-square magical-words"
                        style={{ marginBottom: '8px' }}
                        onClick={() => setIsEdit(false)}
                        title="Cancel"
                    >
                        <IoMdClose fontSize={10} />
                    </div>
                </>
            ) : (
                <div
                    className="ml-2 rounded-circle"
                    onClick={() => onRemove?.(pin, true, true)}
                    title="Delete pin"
                    style={{
                        backgroundColor: '#E5E5E5',
                        cursor:          'pointer',
                        marginBottom:    '8px',
                        padding:         '4px',
                    }}
                >
                    <IoMdClose fontSize={10} />
                </div>
            )}
        </div>
    );
};

export default DraggablePinItem;
